import Highcharts from './_highcharts-base';
import {Options} from 'highcharts';

export default function () {
    $(() => {
        for (const chart of $('.responses-chart')) {
            const options: Options = {
                chart: {
                    width: 70,
                    marginLeft: 0,
                    spacingTop: 10,
                    marginBottom: 36,
                    plotBorderWidth: 0,
                    type: 'columnrange',
                    inverted: true,
                },
                yAxis: [{
                    min: 0,
                    max: 100,
                    title: {
                        text: null
                    },
                    labels: {
                        enabled: false
                    },
                    gridLineWidth: 0,
                }],
                xAxis: {
                    labels: {
                        enabled: false
                    },
                    gridLineWidth: 0,
                    lineWidth: 0,
                },
                plotOptions: {
                    columnrange: {
                        grouping: false
                    },
                },
            };
            new Highcharts.Chart(
                chart,
                $.extend(true, {}, options, $(chart).data('chart'))
            );
        }
    });
}